import request from "@/utils/request";
import { apiConfig } from "../config/api";

//登录
export function login(username, password, captchaKey, captchaCode) {
  var params = {
    username,
    password,
    captchaKey,
    captchaCode
  };

  return request({
    url: apiConfig.auth.api.login,
    method: "post",
    params: params
  });
}

//获取验证码
export function captcha() {
  return request({
    url: apiConfig.auth.api.captcha,
    method: "get"
  });
}

//检查token
export function checkToken() {
  return request({
    url: apiConfig.auth.api.checkToken,
    method: "get"
  });
}

//更新密码
export function updateCurrentPassword(oldPassword, newPassword) {
  return request({
    url: apiConfig.auth.api.changePassword,
    method: "post",
    params: {
      oldPass: oldPassword,
      newPass: newPassword
    }
  });
}

//登出
export function logout() {
  return request({
    url: apiConfig.auth.api.logout,
    method: "post"
  });
}
